import { CONTACT } from "@/data/site";
import SectionHead from "@/components/SectionHead";
import { useLang } from "@/i18n";

const About = () => {
  const t = useLang().t;
  return (
  <section id="about" data-testid="about" className="bg-[#F5F2EB] py-16 sm:py-24">
    <div className="container-site">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div>
          <SectionHead
            testId="about-head"
            align="left"
            eyebrow={t.about.eyebrow}
            title={t.about.title}
          />
          <div className="mt-6 space-y-4 text-base sm:text-lg leading-relaxed text-[#5D4037]">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p className="font-heading font-semibold text-[#3E2723]">
              {t.about.signature}
            </p>
          </div>
        </div>
        <div className="rounded-3xl border border-[#EFEBE4] bg-white p-8 sm:p-10 shadow-sm" data-testid="about-values">
          <p className="eyebrow">{t.about.valuesTitle}</p>
          <ul className="mt-6 space-y-5">
            {t.about.values.map((v) => (
              <li key={v.t} className="border-b border-[#EFEBE4] pb-5 last:border-0 last:pb-0">
                <p className="font-heading text-base sm:text-lg font-bold text-[#3E2723]">{v.t}</p>
                <p className="mt-1 text-sm text-[#5D4037]">{v.d}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
  );
};

export default About;
